import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { CategoryBaseFragmentDoc } from './Category.generated';
export type CategoryBaseWithThumbnailFragment = { thumbnailUrl: string | null, id: string, name: string, url: string, pk: number, slug: string, description: string, metaDescription: string, keywords: string, metaTitle: string, level: number, isWholesale: boolean };

export const CategoryBaseWithThumbnailFragmentDoc = gql`
    fragment CategoryBaseWithThumbnailFragment on CategoryType {
  ...CategoryBaseFragment
  thumbnailUrl(size: "600x0", method: CROP_WEBP)
}
    ${CategoryBaseFragmentDoc}`;